{
  "common.close": "Cerrar",
  "common.athleteFallback": "atleta {id}",
  "splash.title": "{app} — visualización animada de actividades",
  "splash.tagline": "Tus datos de Strava&nbsp;en movimiento",
  "splash.demo": "Demo",
  "tab.query.title": "Mapa de {name}",
  "tab.query.heading": "Consulta de actividades:",
  "tab.query.optDays": "últimos días",
  "tab.query.optActivities": "últimas actividades",
  "tab.query.optIds": "ID de actividades",
  "tab.query.optDates": "Intervalo de fechas",
  "tab.query.idsPlaceholder": "introduce aquí los ID de actividades",
  "tab.query.after": "Desde:",
  "tab.query.before": "Hasta:",
  "tab.query.autozoom": "Zoom automático <i class=\"hf hf-bullseye\"></i> a la consulta tras importar",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Consultar",
  "tab.query.createAccount": "Crea una cuenta o inicia sesión.",
  "tab.query.sports": "Deportes:",
  "tab.query.allSports": "Todos los deportes",
  "tab.query.sportsExcept": "Todos excepto",
  "tab.query.sportsNone": "Ninguno",
  "tab.query.loadingSports": "Cargando deportes…",
  "tab.query.sportsFailed": "No se pudieron cargar los deportes de este mapa",
  "tab.query.noSports": "Aún no hay actividades",
  "tab.activities.title": "Actividades mostradas",
  "tab.activities.clearSelection": "Borrar selección",
  "tab.activities.renderSelected": "Mostrar selección",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom a la selección",
  "tab.controls.title": "Ajustes de capa",
  "tab.controls.timescale": "Escala de tiempo <i>&tau;</i>",
  "tab.controls.timescaleHint": "velocidad de reproducción",
  "tab.controls.period": "Periodo <i>T</i>",
  "tab.controls.periodHint": "actividad ~ modelo",
  "tab.controls.dotSize": "Tamaño del punto",
  "tab.controls.pathWidth": "Grosor del trazo",
  "tab.controls.pathWidthHint": "cero oculta los trazos",
  "tab.controls.colors": "Colores",
  "tab.controls.colorsHint": "girar la paleta",
  "tab.controls.shadows": "Sombras",
  "tab.profile.loginTitle": "Iniciar sesión",
  "tab.profile.anonNote": "Inicia sesión con Strava para ver tus propias actividades y gestionar tu cuenta de Heatflask.",
  "tab.profile.loginLink": "Iniciar sesión con Strava",
  "tab.profile.editOnStrava": "Editar tu perfil en Strava",
  "tab.profile.indexNote": "Indexamos los resúmenes de tus actividades para acceder a ellos rápidamente.",
  "tab.profile.viewIndex": "Ver índice",
  "tab.profile.sharedMaps": "Mapas compartidos",
  "tab.profile.sharedMapsNote": "Desactivado: solo tú puedes ver tus actividades en Heatflask. Activado: cualquier persona con un enlace a tu mapa puede ver las actividades que hayas hecho públicas en Strava. Las privadas siguen siendo solo tuyas. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Cómo funciona la privacidad</a>",
  "tab.profile.logout": "Cerrar sesión",
  "tab.profile.deleteAccount": "Eliminar cuenta",
  "tab.profile.deleteConfirm": "¿Eliminar tu cuenta de Heatflask?\n\nSe borrarán tus actividades indexadas y se revocará el acceso de Heatflask a tus datos de Strava. No se puede deshacer.",
  "tab.profile.languageHeading": "Idioma",
  "tab.profile.languageAuto": "Automático",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">¡Ayúdanos a corregir o añadir traducciones!</a>",
  "tab.profile.unitsHeading": "Unidades",
  "tab.profile.unitsAuto": "Automático",
  "tab.profile.unitsMetric": "Métrico (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Tamaño del texto",
  "tab.profile.textSmaller": "Más pequeño",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Más grande",
  "tab.profile.mapDefaultsHeading": "Valores predeterminados del mapa",
  "tab.profile.mapDefaultsNote": "Empezar con este mapa base, relieve y ajustes de capa cada vez que abras un mapa cuyo enlace no establezca los suyos. Los enlaces que compartas siguen mostrando exactamente lo que ves.",
  "tab.profile.mapDefaultsSave": "Guardar como mis valores predeterminados",
  "tab.profile.mapDefaultsForget": "Olvidar",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Controles",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + arrastrar",
  "tab.info.shiftDragDesc": "Selecciona actividades dentro de un recuadro. En pantalla táctil, toca primero <i class=\"hf-object-group\"></i> y luego arrastra con un dedo. La última actividad seleccionada muestra su detalle, y la lista se desplaza hasta ella.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + arrastrar",
  "tab.info.ctrlDragDesc": "Girar e inclinar el mapa en 3D, o usar dos dedos",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Abrir o cerrar la barra lateral",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Pestaña anterior o siguiente",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Cerrar la barra lateral",
  "tab.info.liveUrlHeading": "URL en vivo",
  "tab.info.liveUrlDesc": "La vista del mapa y los ajustes de la animación se guardan en la URL de la página, así que quien la reciba verá exactamente lo mismo.",
  "tab.info.videoHeading": "Exportar vídeo",
  "tab.info.videoDesc": "El botón <i class=\"hf-video-camera\"></i> graba la animación en MP4: tócalo, ajusta el recuadro sobre la parte del mapa que quieras y vuelve a tocarlo para grabar. Se graba un ciclo completo de la animación, de modo que el vídeo se repite sin cortes; si un ciclo dura más de {max} segundos (el vídeo más largo que acepta Strava), se corta en {max}.",
  "tab.info.contributeHeading": "Colaborar",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Patrocinar en GitHub",
  "tab.info.contactsHeading": "Contacto",
  "map.basemapAndTerrain": "Mapa base y relieve",
  "map.pauseAnimation": "Pausar la animación",
  "map.resumeAnimation": "Reanudar la animación",
  "capture.record": "Grabar vídeo (ciclo de {period} s)",
  "capture.recordTruncated": "Grabar vídeo (un ciclo dura {period} s; solo se grabarán los primeros {max} s)",
  "capture.recordArea": "Grabar el área del recuadro",
  "capture.stop": "Detener la grabación",
  "capture.selectionTooSmall": "la selección es demasiado pequeña",
  "capture.saved": "{name} guardado ({size})",
  "capture.cancelled": "grabación cancelada",
  "capture.failed": "fallo al grabar: {error}",
  "capture.loadingEncoder": "cargando el codificador…",
  "capture.waitingForMap": "esperando a que cargue el mapa…",
  "capture.encoding": "codificando… {percent} %",
  "capture.finalizing": "finalizando…",
  "share.title": "Compartir un enlace a este mapa",
  "share.copied": "enlace copiado",
  "share.copiedUnshared": "enlace copiado, pero tu mapa no está compartido, así que nadie más puede abrirlo. Activa «Mapas compartidos» para cambiarlo.",
  "share.unshared": "Tu mapa no está compartido, así que nadie más puede abrir este enlace. Activa «Mapas compartidos» para cambiarlo.",
  "share.copyThis": "Copia este enlace:",
  "update.available": "Hay una nueva versión de Heatflask disponible.",
  "update.reload": "Recargar",
  "import.title": "Importando",
  "import.stop": "Detener",
  "import.stopping": "deteniendo…",
  "import.contacting": "conectando con Strava…",
  "import.countOf": "Actividades: {received} de {total}",
  "import.count": "Actividades: {received}",
  "import.waitStrava": "En pausa hasta las {time} por el límite de descargas de Strava. Deja esto abierto; recargar no lo acelera.",
  "import.waitRationed": "Ya usaste las descargas rápidas de hoy. El resto sigue a las {time}, más despacio. Deja esto abierto.",
  "import.dailyLimit": "Se agotó el límite diario de descargas de Strava. Vuelve a intentarlo después de las {time}.",
  "import.dailyRationed": "Ya usaste tu parte de descargas de Strava de hoy. Vuelve a intentarlo después de las {time}.",
  "import.noActivitiesYet": "Tu cuenta de Strava todavía no tiene actividades. Graba o sube una en Strava y aparecerá aquí.",
  "table.noActivities": "sin actividades",
  "table.untitled": "(sin título)",
  "activities.pageTitle": "{app} — índice de actividades",
  "activities.heading": "Índice de actividades",
  "activities.fetching": "Obteniendo actividades...",
  "activities.rateLimit": "Límite de peticiones de Strava alcanzado; se reanuda a las {time}",
  "activities.noData": "Lo sentimos, no hay datos &#128577;",
  "activities.colServerCache": "Trazo en caché en el servidor (Mongo)",
  "activities.colBrowserCache": "Trazo en caché en este navegador",
  "activities.cachedServer": "El trazo de {id} está en caché en el servidor",
  "activities.notCachedServer": "El trazo de {id} no está en caché en el servidor",
  "activities.cachedBrowser": "El trazo de {id} está en caché en este navegador",
  "activities.notCachedBrowser": "El trazo de {id} no está en caché en este navegador",
  "sport.AlpineSki": "Esquí alpino",
  "sport.BackcountrySki": "Esquí de travesía",
  "sport.Badminton": "Bádminton",
  "sport.Basketball": "Baloncesto",
  "sport.Canoeing": "Canoa",
  "sport.Cricket": "Críquet",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Baile",
  "sport.EBikeRide": "Salida en bici eléctrica",
  "sport.Elliptical": "Elíptica",
  "sport.EMountainBikeRide": "Salida en BTT eléctrica",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Salida en gravel",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Senderismo",
  "sport.IceSkate": "Patinaje sobre hielo",
  "sport.InlineSkate": "Patinaje en línea",
  "sport.Kayaking": "Kayak",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Salida en BTT",
  "sport.NordicSki": "Esquí de fondo",
  "sport.Padel": "Pádel",
  "sport.PhysicalTherapy": "Fisioterapia",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Ráquetbol",
  "sport.Ride": "Salida en bici",
  "sport.RockClimbing": "Escalada",
  "sport.RollerSki": "Esquí sobre ruedas",
  "sport.Rowing": "Remo",
  "sport.Run": "Carrera",
  "sport.Sail": "Vela",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Raquetas de nieve",
  "sport.Soccer": "Fútbol",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Escaladora",
  "sport.StandUpPaddling": "Paddle surf",
  "sport.Surfing": "Surf",
  "sport.Swim": "Natación",
  "sport.TableTennis": "Tenis de mesa",
  "sport.Tennis": "Tenis",
  "sport.TrailRun": "Trail running",
  "sport.Velomobile": "Velomóvil",
  "sport.VirtualRide": "Salida en bici virtual",
  "sport.VirtualRow": "Remo virtual",
  "sport.VirtualRun": "Carrera virtual",
  "sport.Volleyball": "Voleibol",
  "sport.Walk": "Caminata",
  "sport.WeightTraining": "Entrenamiento con pesas",
  "sport.Wheelchair": "Silla de ruedas",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Entrenamiento",
  "sport.Yoga": "Yoga"
}
